import { ADMIN_GROUP } from '@client/config/client.config';

export { ADMIN_GROUP };

export const isAdminUser = (userGroups) =>
  Array.isArray(userGroups) && userGroups.includes(ADMIN_GROUP);
